import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export enum OemListType {
    Normal = 0,
    UseLot
}

/*const mapSearchFields: any = {
    general1: 'generalText1',
    general2: 'generalText2',
    general3: 'generalText3',
    date: {from: 'dateFrom', to: 'dateTo'},
    date1: {from: 'dateFrom1', to: 'dateTo1'},
    date2: {from: 'dateFrom2', to: 'dateTo2'},
    location1: 'location1Text',
    location2: 'location2Text',
    location3: 'location3Text',
    number: {from: 'numberFrom', to: 'numberFrom'},
    number1: {from: 'numberFrom1', to: 'numberTo1'},
    number2: {from: 'numberFrom2', to: 'numberTo2'},
}*/

export class OeMblListItem extends SearchModelBase {
    closed: string = '';
    shipmentType: string = '';
    invStat: string = '';
    billStat: string = '';
    crDbStat: string = '';
    refNo: string = '';
    hblCount: string = '';
    lotNo: string = '';
    branch: string = '';
    bookingNo: string = '';
    mblNo: string = '';
    agentId: number = 0;
    agentSName: string = '';
    vessel: string = '';
    cutOffDate: string | null = null;
    fromCutOffDate: string | null = null;
    toCutOffDate: string | null = null;
    etd: string | null = null;
    fromEtd: string | null = null;
    toEtd: string | null = null;
    eta: string | null = null;
    fromEta: string | null = null;
    toEta: string | null = null;
    svccNo: string = '';
    containerNo: string = '';
    conType: string = '';
    loadingPort: string = '';
    disCharge: string = '';
    voyage: string = '';
    carrierSName: string = '';
    pLofRec: string = '';
    createdAt: string | null = null;
    postDate: string | null = null;
    id: number = 0;
    pimsLinkId: number = 0;
    emptyRtnName: string = '';
    finalDest: string = '';
    recognized: string = '';
    status: string = '';

    // cloud
    /**
     * 1 = Coload, C=Consol, '' = None
     */
    coload:string = '';

    /**
     * F = FCL, L=LCL, O = FAK
     */
     lclfcl: string = '';
     moveType: string = '';
     blType: string = '';
     agentRefNo: string = '';
     bookCfrm: string | null = null;
     fromBookCfrm: string | null = null;
     toBookFrom: string | null = null;
     sedSent: string | null = null;
     fromSedSent: string | null = null;
     toSedSent: string | null = null;
     dlvrToCarr: string | null = null;
     fromDlvrToCarr: string | null = null;
     toDlvrToCarr: string | null = null;
     u2Date: string | null = null;
     fromU2Date: string | null = null;
     toU2Date: string | null = null;
     u2ID: string = '';
     u1ID: string = '';
     projectNo: string='';
     paidStatus: string = '';
     paidDate: string | null = null;
     fromPaidDate: string | null = null;
     toPaidDate: string | null = null;
     fromCreatedAt: string | null = null;
     toCreatedAt: string | null = null;

     //Track Event
     lastEvent: string = '';
     lastEventDate: string | null = null;
 
    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', align: XCol.XAlignType.Center, hiddenInColumnSetup: true }),
        XCol.Create({ col: 1, text: 'R', width: 30, dataIndex: 'recognized', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, hiddenInColumnSetup: true }),
        XCol.Create({ col: 30, text: 'D/ID', width: 35, dataIndex: 'shipmentType', align: XCol.XAlignType.Center, noNullOrEmptySearch: true }),
        
        XCol.Create({ col: 2, text: 'Cargo', width: 80, dataIndex: 'lclFcl', noNullOrEmptySearch: true }),
        XCol.Create({ col: 3, text: 'Ref. #', width: 100, dataIndex: 'refNo', defaultColumnFocus: true }),
        XCol.Create({ col: 4, text: 'Last Event', width: 85, dataIndex: 'lastEvent', noNullOrEmptySearch: true }),
        XCol.Create({ col: 6, text: 'BR', width: 40, dataIndex: 'branch' }),
        XCol.Create({ col: 7, text: 'HBL(s)', width: 40, dataIndex: 'hblCount', noNullOrEmptySearch: true }),
        XCol.Create({ col: 8, text: 'Lot ID', width: 80, dataIndex: 'lotNo' }),
        XCol.Create({ col: 9, text: 'Carrier Booking', width: 100, dataIndex: 'bookingNo' }),
        XCol.Create({ col: 10, text: 'MBL', width: 100, dataIndex: 'mblNo' }),
        XCol.Create({ col: 11, text: 'Project ID', width:100, dataIndex:'projectNo' }),
        XCol.Create({ col: 12, text: 'Agent', width: 120, dataIndex: 'agentSName' }),
        XCol.Create({ col: 13, text: 'Vessel', width: 120, dataIndex: 'vessel' }),
        XCol.Create({ col: 14, text: 'CUTOFF', width: 75, dataIndex: 'cutOffDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 15, text: 'ETD', width: 75, dataIndex: 'etd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 16, text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 17, text: 'Org. B/L Type', width: 80, dataIndex: 'blType', visible: false  }),
        XCol.Create({ col: 18, text: 'Move Type', width: 80, dataIndex: 'moveType', noNullOrEmptySearch: true }),
        XCol.Create({ col: 19, text: 'SVC Contract', width: 80, dataIndex: 'svccNo', visible: false }),
        XCol.Create({ col: 20, text: 'Container', width: 90, dataIndex: 'containerNo' }),
        XCol.Create({ col: 21, text: 'Type', width: 60, dataIndex: 'conType' }),
        XCol.Create({ col: 22, text: 'Loading Port', width: 120, dataIndex: 'loadingPort' }),
        XCol.Create({ col: 23, text: 'Discharge Port', width: 120, dataIndex: 'disCharge' }),
        XCol.Create({ col: 24, text: 'Voyage', width: 60, dataIndex: 'voyage' }),
        XCol.Create({ col: 25, text: 'Freight Vendor', width: 120, dataIndex: 'carrierSName' }),
        XCol.Create({ col: 26, text: 'Place of Receipt', width: 120, dataIndex: 'pLofRec', visible: false }),
        XCol.Create({ col: 27, text: 'FRT CHRG', width: 60, dataIndex: 'paidStatus' }),
        XCol.Create({ col: 28, text: 'Paid', width: 75, dataIndex: 'paidDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        
        XCol.Create({ col: 31, text: 'INV', width: 35, dataIndex: 'invStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false }),
        XCol.Create({ col: 32, text: 'BIL', width: 35, dataIndex: 'billStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false }),
        XCol.Create({ col: 33, text: 'CrDb', width: 35, dataIndex: 'crDbStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false }),
        
        XCol.Create({ col: 34, text: 'Create Date', width: 100, dataIndex: 'createdAt', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: false  }),
        XCol.Create({ col: 35, text: 'Create by', width: 80, dataIndex: 'u1ID', visible: false  }),
        XCol.Create({ col: 36, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: false  }),
        XCol.Create({ col: 37, text: 'Update by', width: 80, dataIndex: 'u2ID', visible: false  }),

        // XCol.Create({ col: 7, text: 'Co-Loading', width: 60, dataIndex: 'coload', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        //XCol.Create({ col: 17, text: 'Agent Ref. No', width: 100, dataIndex: 'agentRefNo', visible: false }),
        //XCol.Create({ col: 19, text: 'Carrier Book', width: 75, dataIndex: 'bookCfrm', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        //XCol.Create({ col: 20, text: 'SED Cutoff', width: 75, dataIndex: 'sedSent', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        //XCol.Create({ col: 29, text: 'Final Destination', width: 120, dataIndex: 'finalDest', visible: false }),
        // XCol.Create({ col: 23, text: 'Cutoff Date', width: 75, dataIndex: 'cutOffDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
    ];

    public static getExportCollection(ltype:OemListType, useBranch: boolean): XCol.XExportColumn[] {
        let expCollection = _.cloneDeep(this.ExportCollection);
        if (ltype === OemListType.Normal) expCollection = expCollection.filter(x => x.dataIndex !== "lotNo");
        if (!useBranch) expCollection = expCollection.filter(x => x.dataIndex !== 'branch');
        return expCollection;
    };

    public static MapOeSearchFields: {[key: string]: {[key: string]: string}} = {
        cutOffDate: {from: 'fromCutOffDate', to: 'toCutOffDate'},
        etd: {from: 'fromEtd', to: 'toEtd'},
        eta: {from: 'fromEta', to: 'toEta'},
        bookCfrm: {from: 'fromBookCfrm', to: 'toBookFrom'},
        sedSent: {from: 'fromSedSent', to: 'toSedSent'},
        dlvrToCarr: {from: 'fromDlvrToCarr', to: 'toDlvrToCarr'},
        createdAt: {from: 'fromCreatedAt', to: 'toCreatedAt'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
        paidDate: {from: 'fromPaidDate', to: 'toPaidDate'},
    }

    public static OrderBy = {orderBy: OeMblListItem.prototype.id, orderByAscending: false};

    public static formatData(data: OeMblListItem[]) {
        // return data.sort((a, b) => (!a.u2Date || !b.u2Date || a.u2Date < b.u2Date) ? 1 : -1).map((d: OeMblListItem) => ({
        return data.map((d: OeMblListItem) => ({
            ...d, coload: d.coload === '1',
        }));
    }
}
